// extracted by mini-css-extract-plugin
export default {"button":"Button_button__kvm9u","primary":"Button_primary__l1fMe","secondary":"Button_secondary__CMQKT","ghost":"Button_ghost__A4eJh","fullWidth":"Button_fullWidth__1UqvI"};